import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

export default function UltrafiltrationChart({ data }) {
  return (
    <div className="rounded-2xl bg-white p-3">
      <h3 className="mb-2 text-2xl font-bold text-navy-900">💧 每天總洗水量</h3>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
          <XAxis dataKey="date" tick={{ fontSize: 14 }} />
          <YAxis tick={{ fontSize: 14 }} />
          <Tooltip labelStyle={{ fontSize: 16 }} contentStyle={{ fontSize: 18 }} />
          <Bar dataKey="total_ultrafiltration" name="總洗水量" fill="#0b1f3a" barSize={22} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
